import styled from 'styled-components';

export const SortingIconBox = styled.div`
  transform: ${props => props.isAscending && 'rotate(180deg)'};
  transition: 0.2s;
`;
